<frontend-pull-refresh></frontend-pull-refresh>

<section class="px-3 pb-3">
  <h1 class="pt-3">Services Settings</h1>
  <form *ngIf="servicesForm" role="form" [formGroup]="servicesForm" novalidate>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="services-enabled" class="col-form-label lead">Enable Services</label>
        <p>Enable the Services feature.</p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox"
                   class="form-check-input"
                   id="services-enabled"
                   name="servicesEnabled"
                   formControlName="enabled">Enable
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="servicesForm.get('enabled').value">
      <div class="row form-group" >
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="services-label" class="lead col-form-label">Services label</label>
          <p>What is a service called?</p>
        </div>
        <div class="col-sm-5 col-md-6 col-lg-3 mt-2">
          <input type="text"
                 class="form-control"
                 id="services-label"
                 formControlName="label"
                 name="servicesSettingsLabel"
                 [class.is-invalid]="servicesForm.get('label').invalid && servicesForm.get('label').touched" />
          <control-messages [control]="servicesForm.get('label')"></control-messages>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="services-show-on-pages" class="col-form-label lead">
            Display on Waitlist <br/> &amp; {{ who.location.displayOptions.labels.reservation_plural | titlecase }} pages
          </label>
        </div>
        <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
          <div class="form-check">
            <label class="form-check-label">
              <input type="checkbox"
                     class="form-check-input"
                     id="services-show-on-pages"
                     name="showOnPages"
                     formControlName="showOnPages">Enable
            </label>
          </div>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label class="lead col-form-label">Sort by</label>
          <p>Sort your services.</p>
        </div>
        <div class="col-sm-5 col-md-6 col-lg-3 mt-2">
          <div class="form-group">
            <frontend-dropdown-plain
              elementId="services-sort"
              formControlName="sort"
              [items]="sort"
            ></frontend-dropdown-plain>
          </div>
        </div>
      </div>

      <div class="row form-group" [hidden]="!(who.account.features.paymentAccepting && who.location.integrations?.stripe?.enabled)">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="services-allow-charge" class="col-form-label lead">Allow charge via Stripe</label>
          <p>Services should have price and description to be charged for. </p>
        </div>
        <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
          <div class="form-check">
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                id="services-allow-charge"
                name="allowCharge"
                formControlName="allowCharge">Enable
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-sm-3 offset-sm-3 offset-md-2">
        <button class="btn btn-info"
                [disabled]="servicesForm.pristine || !servicesForm.valid"
                angularticsCategory="settings"
                angulartics2On="click"
                angularticsAction="Save Services Settings"
                (click)="saveServicesSettings(servicesForm.value)">Save
        </button>
      </div>
    </div>

    <div *ngIf="servicesForm.get('enabled').value">
      <h2 class="pt-3">Services</h2>
      <tr-services-list
        #serviceList
        [serviceSettings]="serviceSettings"
        [reservationsLabel]="who.location.displayOptions.labels.reservation_plural"
        [availableSchedules]="availableSchedules"
        [bookingOptions]="who.location.bookingOptions"
        [isUserOnFreePlan]="isUserOnFreePlan"
        [allowCharge]="servicesForm.get('allowCharge').value"
      >
      </tr-services-list>
    </div>
    <div class="add-new">
      <span class="add-new-blocker" slot="fixed">
        <button
          *ngIf="servicesForm.get('enabled').value"
          type="button"
          class="btn btn-accent btn-circle"
          (click)="addEditService()"
          id="addEditParty-button"
          [disabled]="!who.location.serviceSettings.enabled"
        >
          <tr-icon [icon]="icon.plus" [color]="color.white" [size]="size.extraLarge"></tr-icon>
        </button>
      </span>
    </div>
  </form>

</section>
